import { render } from "./KnowledgeAgentPage.vue?vue&type=template&id=225d9835&scoped=true"
import script from "./KnowledgeAgentPage.vue?vue&type=script&lang=js"
export * from "./KnowledgeAgentPage.vue?vue&type=script&lang=js"

import "./KnowledgeAgentPage.vue?vue&type=style&index=0&id=225d9835&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225d9835"]])

export default __exports__